import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 12000-12999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const selectionSetErrors = {
  // Live at 2 sites in selectionSetMongo.service.ts (identical text). Confirmed safe —
  // SelectionSetTable.tsx branches on this exact code, sets local state, never reads errorMessage.
  SELECTION_SET_ALREADY_EXISTS: {
    errorCode: 12000,
    errorMessage: t("A selection set with this name already exists on this file version."),
    isDynamic: false,
  },
  // The selectionSet module's only non-generic site; its other four literally say
  // "Something went wrong".
  SELECTION_SET_ITEMS_ADD_FAILED: {
    errorCode: 12001,
    errorMessage: t("Failed to add selection set items."),
    isDynamic: false,
  },
  // Off INSUFFICIENT_PERMISSION (7012): the set is deleted, which is a record-state fact rather than
  // an access decision. Split by operation because each sentence names its own verb.
  SELECTION_SET_DELETED_CANNOT_RENAME: {
    errorCode: 12002,
    errorMessage: t("This selection set has been deleted, so it cannot be renamed."),
    isDynamic: false,
  },
  SELECTION_SET_DELETED_CANNOT_REPLACE_ITEMS: {
    errorCode: 12003,
    errorMessage: t("This Selection Set has been deleted, so its items cannot be replaced."),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
